// Each icon is an array of SVG element objects: { tag, ...attrs }
// All icons share viewBox="0 0 24 24", stroke="currentColor", fill="none"

export const icons = {
  alert: [
    {
      d: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z',
      tag: 'path',
    },
    { tag: 'line', x1: 12, x2: 12, y1: 9, y2: 13 },
    { 'stroke-width': 2.5, tag: 'line', x1: 12, x2: 12.01, y1: 17, y2: 17 },
  ],
  bell: [
    { d: 'M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9', tag: 'path' },
    { d: 'M13.73 21a2 2 0 0 1-3.46 0', tag: 'path' },
  ],
  calendar: [
    { height: 18, rx: 2, ry: 2, tag: 'rect', width: 18, x: 3, y: 4 },
    { tag: 'line', x1: 16, x2: 16, y1: 2, y2: 6 },
    { tag: 'line', x1: 8, x2: 8, y1: 2, y2: 6 },
    { tag: 'line', x1: 3, x2: 21, y1: 10, y2: 10 },
  ],
  check: [{ points: '20 6 9 17 4 12', tag: 'polyline' }],
  chevron: [{ points: '9 18 15 12 9 6', tag: 'polyline' }],
  close: [
    { tag: 'line', x1: 18, x2: 6, y1: 6, y2: 18 },
    { tag: 'line', x1: 6, x2: 18, y1: 6, y2: 18 },
  ],
  cloud: [{ d: 'M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z', tag: 'path' }],
  'cloud-upload': [
    { points: '16 16 12 12 8 16', tag: 'polyline' },
    { tag: 'line', x1: 12, x2: 12, y1: 12, y2: 21 },
    { d: 'M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3', tag: 'path' },
  ],
  copy: [
    { height: '13', rx: '2', tag: 'rect', width: '13', x: '9', y: '9' },
    { d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1', tag: 'path' },
  ],
  document: [
    { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z', tag: 'path' },
    { points: '14 2 14 8 20 8', tag: 'polyline' },
    { tag: 'line', x1: 16, x2: 8, y1: 13, y2: 13 },
    { tag: 'line', x1: 16, x2: 8, y1: 17, y2: 17 },
    { points: '10 9 9 9 8 9', tag: 'polyline' },
  ],
  download: [
    { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', tag: 'path' },
    { points: '7 10 12 15 17 10', tag: 'polyline' },
    { tag: 'line', x1: 12, x2: 12, y1: 15, y2: 3 },
  ],
  edit: [
    { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', tag: 'path' },
    { d: 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z', tag: 'path' },
  ],
  'google-drive': [
    { d: 'M9 3h6l6 10-3 5h-12l-3-5z', tag: 'path' },
    { d: 'M12 7l3 5H9z', tag: 'path' },
  ],
  history: [
    { tag: 'line', x1: 8, x2: 21, y1: 6, y2: 6 },
    { tag: 'line', x1: 8, x2: 21, y1: 12, y2: 12 },
    { tag: 'line', x1: 8, x2: 21, y1: 18, y2: 18 },
    { 'stroke-width': 2.5, tag: 'line', x1: 3, x2: 3.01, y1: 6, y2: 6 },
    { 'stroke-width': 2.5, tag: 'line', x1: 3, x2: 3.01, y1: 12, y2: 12 },
    { 'stroke-width': 2.5, tag: 'line', x1: 3, x2: 3.01, y1: 18, y2: 18 },
  ],
  loading: [
    {
      d: 'M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83',
      tag: 'path',
    },
  ],
  lock: [
    { height: 11, rx: 2, ry: 2, tag: 'rect', width: 18, x: 3, y: 11 },
    { d: 'M7 11V7a5 5 0 0 1 10 0v4', tag: 'path' },
  ],
  log: [
    { d: 'M11 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6', tag: 'path' },
    { d: 'M17.5 2.5a2.121 2.121 0 0 1 3 3L12 14l-4 1 1-4 8.5-8.5z', tag: 'path' },
  ],
  menu: [
    { tag: 'line', x1: 3, x2: 21, y1: 6, y2: 6 },
    { tag: 'line', x1: 3, x2: 21, y1: 12, y2: 12 },
    { tag: 'line', x1: 3, x2: 21, y1: 18, y2: 18 },
  ],
  moon: [{ d: 'M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z', tag: 'path' }],
  onedrive: [
    { d: 'M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', tag: 'path' },
    { d: 'M17 19a4 4 0 0 0-3-7.5V11a5 5 0 0 0-10 0v.5A4 4 0 0 0 7 19h10z', tag: 'path' },
  ],
  scan: [
    {
      d: 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z',
      tag: 'path',
    },
    { cx: 12, cy: 13, r: 4, tag: 'circle' },
  ],
  settings: [
    { cx: 12, cy: 12, r: 3, tag: 'circle' },
    {
      d: 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z',
      tag: 'path',
    },
  ],
  shift: [
    { cx: 12, cy: 12, r: 9, tag: 'circle' },
    { points: '12 7 12 12 15.5 14', tag: 'polyline' },
  ],
  sun: [
    { cx: 12, cy: 12, r: 5, tag: 'circle' },
    { tag: 'line', x1: 12, x2: 12, y1: 1, y2: 3 },
    { tag: 'line', x1: 12, x2: 12, y1: 21, y2: 23 },
    { tag: 'line', x1: 4.22, x2: 5.64, y1: 4.22, y2: 5.64 },
    { tag: 'line', x1: 18.36, x2: 19.78, y1: 18.36, y2: 19.78 },
    { tag: 'line', x1: 1, x2: 3, y1: 12, y2: 12 },
    { tag: 'line', x1: 21, x2: 23, y1: 12, y2: 12 },
    { tag: 'line', x1: 4.22, x2: 5.64, y1: 19.78, y2: 18.36 },
    { tag: 'line', x1: 18.36, x2: 19.78, y1: 5.64, y2: 4.22 },
  ],
  unlock: [
    { height: 11, rx: 2, ry: 2, tag: 'rect', width: 18, x: 3, y: 11 },
    { d: 'M7 11V7a5 5 0 0 1 9.9-1', tag: 'path' },
    { tag: 'line', x1: 15, x2: 21, y1: 10, y2: 16 },
    { tag: 'line', x1: 21, x2: 15, y1: 10, y2: 16 },
  ],
  upload: [
    { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', tag: 'path' },
    { points: '17 8 12 3 7 8', tag: 'polyline' },
    { tag: 'line', x1: 12, x2: 12, y1: 3, y2: 15 },
  ],
  user: [
    { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', tag: 'path' },
    { cx: '12', cy: '7', r: '4', tag: 'circle' },
  ],
};
